import React from 'react';
import TitleSet from '../sharecomponents/titleset';
import LoginCheck from "../sharecomponents/LoginCheck";
//import {Redirect} from "react-router-dom";

class ManagerLogining extends React.Component{

    // _GotoURL = "";
    _LogingWord = "登入中．．．．．"
    constructor(props){
        super(props);
        this.state = {
            fireRedirect: false
        }; 
    }

    componentDidMount(){        
        //console.log(this.props);
        if(!this.props.location.state || this.props.location.state.LoginCid.length === 0)
        {
            window.location.href = "https://recruit.1111.com.tw";            
        }
        else
        {

        const cid = this.props.location.state.LoginCid;
        LoginCheck(cid)
        .then((ApiLogined) => {
            //console.log(ApiLogined);
            if(ApiLogined.msg){
                alert(ApiLogined.msg);
                this._LogingWord = ApiLogined.msg;
            }
            else{
              if(ApiLogined.Logined >= 1) {
                this._LogingWord = "將為您導向管理頁面！";                
                this.props.history.push({
                    pathname: '/managerweb/' + cid,
                    state: { detail: cid }
                });
              }
              else if(ApiLogined.Logined < 0) {
                this._LogingWord = "將為您導向求才招募系統！";
                alert("您沒有權限使用！");
                window.location.href = ApiLogined.Goto;
              }
              else
              {
                this._LogingWord = "將為您導向登入頁面！";
                alert("請先登入！");
                //this._GotoURL = ApiLogined.Goto;
                window.location.href = ApiLogined.Goto;
                this.setState({ fireRedirect: true });
              }
            }
          });
        }
       
           
        
    }

    // componentWillUnmount() {
    //     this._GotoURL = "";
    //   }

      render(){
        //console.log('render')
        const URL = [
            '/assetsBK/vendor/jquery/jquery.min.js',
            '/assetsBK/vendor/bootstrap/js/bootstrap.bundle.min.js',
            '/assetsBK/js/sb-admin-2.min.js'
        ];
    
        let companyName = '1111人力銀行';
        let companyMeta = {
            keywords: '1111,人力,徵才',
            description: '1111人力銀行'
        }
        const styleSheet = [
            '/assetsBK/vendor/fontawesome-free/css/all.min.css',
            'https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i',
            '/assetsBK/css/sb-admin-2.css'
        ]
    
        /* if(this.state.fireRedirect) {
            return <Redirect to={this._GotoURL} />
        } */
    
        return (

            <div className="bg-gradient-primary">
                <TitleSet title={companyName} meta={companyMeta} style={styleSheet} script={URL} />
                <div>    
                    <div className="row  justify-content-center">
    
                        <div>
    
                            <div className="card o-hidden border-0 shadow-lg my-5">
                                <div className="card-body">
                                    <div className="row">
                                            <div>
                                                <div className="text-center">
                                                    <img src='/image/benefit-1111.png' alt='1111'/>
                                                    <hr />
                                                    <h1 className="h4 text-gray-900 mb-4">{this._LogingWord}</h1>
                                                </div>
    
                                                {/* <form className="user">
                                                    <div className="form-group">
                                                        <input type="text" className="form-control form-control-user" id="InputID" aria-describedby="emailHelp" onChange={changeLoginHandler} value={loginNumber} placeholder="請輸入客戶代碼" />
                                                    </div>
                                                    <div className="form-group">
                                                        <input type="password" className="form-control form-control-user" id="InputPassword" placeholder="請輸入密碼" onChange={changePasswordHandler}  value={loginPassword} />
                                                    </div>
                                                    <div className="form-group">
                                                        <div className="custom-control custom-checkbox small">
                                                        </div>
                                                    </div>
                                                    <a href="index.html" className="btn btn-primary btn-user btn-block" onClick={loginHandler}>
                                                        Login
                                                    </a>
                                                    <hr />
                                                </form> */}
                                            </div>
                                    </div>
                                </div>
                            </div>
    
                        </div>
    
                    </div>
    
                </div>
            </div>
    
    
        )
      }
}

export default ManagerLogining;